import React from 'react'
import styled from 'styled-components'

import {_makeCapitalize} from '../../utils/helpers'

export default ({lang, img}) => {
  return (
    <Container>
      <LangImage src={img}/>
      <TextContainer>
        <MainTitle>{_makeCapitalize(lang)}</MainTitle>
        { lang === 'korean' ? <Native>Native</Native> : null}
      </TextContainer>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  @media(min-width: 900px) {
    width: auto;
  }
  @media(min-width: 1100px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 0.7rem 2.5rem;
  }
`
const LangImage = styled.img`
  margin-right: 1.3rem;
  @media(min-width: 1100px) {
    margin-right: 0;
  }
`
const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
const MainTitle = styled.p`
  font-size: 1.8rem;
  color: ${props => props.theme.beige};
  font-family: DINMed;
  font-weight: 100;
  width: 100%;
  text-align: center;
`
const Native = styled.p`
  font-size: 1.2rem;
  color: ${props => props.theme.beige};
  font-family: DINMed;
  font-weight: 100;
  width: 100%;
`